(function () {

    /* =========================
       1. ALT ATTRIBUTE CLEANER
       ========================= */
    const imgSelector = 'img.needsclick[class*="kl-private-reset-css"]';

    function clearAlt() {
        document.querySelectorAll(imgSelector).forEach(img => {
            img.setAttribute("alt", "");

            Object.defineProperty(img, "alt", {
                set(value) {},
                get() { return ""; },
                configurable: true
            });
        });
    }

    clearAlt();


    /* =========================
       2. H1 -> H2 + CENTER ALIGN
       ========================= */
    const containerId = "rich-text-01KV9BC9CJ49GRHMM7YEFZBDW5";

    function updateHeading() {
        const container = document.getElementById(containerId);
        if (!container) return;

        const h1 = container.querySelector("h1");
        if (!h1) return;

        const h2 = document.createElement("h2");
        h2.innerHTML = h1.innerHTML;
        h2.style.cssText = h1.style.cssText;
        h2.style.textAlign = "center";

        h1.replaceWith(h2);
    }

    updateHeading();


    /* =========================
       3. COOKIE CONSENT LOGIC
       ========================= */
    const observer = new MutationObserver(() => {

        /* ---- alt cleanup ---- */
        clearAlt();

        /* ---- heading update ---- */
        updateHeading();

        /* ---- cookie consent ---- */
        const consentHost = document.querySelector('csm-cookie-consent');
        if (!consentHost || !consentHost.shadowRoot) return;

        const root = consentHost.shadowRoot;

        if (window.innerWidth > 1024) {
            const btn = root.querySelector('.isense-cc-submit-consent');

            if (btn && !btn.dataset.focusBound) {
                btn.dataset.focusBound = 'true';

                btn.addEventListener('click', function () {
                    setTimeout(() => {
                        const emailInput = document.querySelector(
                            '#email_01KP3YVJ0GAH7CJXPNMPN7ADDP'
                        );
                        if (emailInput) emailInput.focus();
                    }, 500);
                });
            }

            return;
        }

        function updateMobileInertState() {

            root.querySelectorAll('.csm-native-cookie-details-collapse')
                .forEach(section => {

                    const trigger = root.querySelector(
                        `[aria-controls="${section.id}"]`
                    );

                    const isExpanded =
                        trigger &&
                        trigger.getAttribute('aria-expanded') === 'true';

                    if (isExpanded) {
                        section.removeAttribute('inert');
                        section.removeAttribute('aria-hidden');
                    } else {
                        section.setAttribute('inert', '');
                        section.setAttribute('aria-hidden', 'true');
                    }
                });

            root.querySelectorAll('.csm-native-preferences-container > div')
                .forEach(container => {

                    const height = container.style.height;

                    if (
                        height === '0px' ||
                        getComputedStyle(container).height === '0px'
                    ) {
                        container.setAttribute('inert', '');
                        container.setAttribute('aria-hidden', 'true');
                    } else {
                        container.removeAttribute('inert');
                        container.removeAttribute('aria-hidden');
                    }
                });
        }

        updateMobileInertState();

        root.querySelectorAll('[aria-controls]').forEach(trigger => {

            if (trigger.dataset.inertBound) return;

            trigger.dataset.inertBound = 'true';

            trigger.addEventListener('click', () => {
                setTimeout(updateMobileInertState, 50);
                setTimeout(updateMobileInertState, 350);
            });
        });

        root.querySelectorAll('.csm-native-preferences-container > div')
            .forEach(container => {

                if (container.dataset.heightObserverBound) return;

                container.dataset.heightObserverBound = 'true';

                const heightObserver = new MutationObserver(() => {
                    updateMobileInertState();
                });

                heightObserver.observe(container, {
                    attributes: true,
                    attributeFilter: ['style']
                });
            });
    });

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });

})();